const StylesProvider = ({ children }) => children;

export default StylesProvider;
